<template>
  <q-page padding>
    <q-tabs
      v-model="tab"
      active-color="primary"
      active-bg-color="grey-1"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-route-tab
        to="/"
        name="overview"
        label="Dashboard"
        exact
      />
      <unreviewed-user-clients-posts-tab />
      <escalated-user-clients-posts-tab  />
      <flagged-user-clients-posts-tab />
    </q-tabs>
    <q-tab-panels v-model="tab" class="bg-grey-1 q-px-md" animated>
      <q-tab-panel name="overview" class="no-scroll">
        <overview :account-id="accountId" :user-id="userId" />
      </q-tab-panel>
      <q-tab-panel name="unreviewed" class="no-scroll">
        <unreviewed-user-clients-posts @total="numUnreviewed = $event" />
      </q-tab-panel>
      <q-tab-panel name="escalated" class="no-scroll">
        <escalated-user-clients-posts @total="numEscalated = $event" />
      </q-tab-panel>
      <q-tab-panel name="flagged" class="no-scroll">
        <flagged-user-clients-posts />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<style>
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserContextMixin } from '@/mixins';
import recognition from '@/auth/recognition';
import UnreviewedUserClientsPostsTab from '@/social/post/list/user/UnreviewedUserClientsPostsTab.vue';
import UnreviewedUserClientsPosts from '@/social/post/list/user/UnreviewedUserClientsPosts.vue';
import EscalatedUserClientsPostsTab from '@/social/post/list/user/EscalatedUserClientsPostsTab.vue';
import EscalatedUserClientsPosts from '@/social/post/list/user/EscalatedUserClientsPosts.vue';
import FlaggedUserClientsPostsTab from '@/social/post/list/user/FlaggedUserClientsPostsTab.vue';
import FlaggedUserClientsPosts from '@/social/post/list/user/FlaggedUserClientsPosts.vue';
import ShowPostMixin from '@/social/post/ShowPostMixin';
import Overview from './Overview.vue';

interface Data {
  tab: string,
  numUnreviewed: number,
  numEscalated: number,
}

export default defineComponent({
  mixins: [UserContextMixin, ShowPostMixin],
  components: {
    UnreviewedUserClientsPostsTab,
    UnreviewedUserClientsPosts,
    EscalatedUserClientsPostsTab,
    EscalatedUserClientsPosts,
    FlaggedUserClientsPostsTab,
    FlaggedUserClientsPosts,
    Overview,
  },
  props: {
    accountId: {
      type: Number,
      default() {
        return recognition.getAccountId();
      },
    },
    userId: {
      type: Number,
      default() {
        return recognition.getUserId();
      },
    },
  },
  data(): Data {
    return {
      tab: 'overview',
      numUnreviewed: 0,
      numEscalated: 0,
    };
  },
  meta: {
    title: 'Dashboard',
  },
});
</script>
